define([
	"dojo/_base/declare",
	"csi/heading/_base",
	"csi/core/Key",
	"csi/xml"
], function(declare, heading, Key, xml) {

	return declare(null, {

		reserveContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: change the context to Care Symbol and index to language
			var languageSysID = ctx.getNode().SysID;
			var careSymbolURL = ctx.getNodeContextURL();

			ctx.pushParams().setNodeURL(careSymbolURL);
			ctx.keyValue = languageSysID;
			this.inherited(arguments);
		},

		releaseContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: pop context if pushed above
			ctx.pop();
			ctx.keyValue = null;
			this.inherited(arguments);
		},

		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: disable filtering
			return null;
		}

	});
});